/** Shared schema.org builders for state and game pages. */

export interface Faq { q: string; a: string }

export function faqPageSchema(faqs: Faq[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbSchema(items: Array<{ name: string; item: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.item,
    })),
  };
}

export function articleSchema(input: {
  headline: string;
  description: string;
  path: string;
  image?: string;
  section?: string;
  keywords?: string[];
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: input.headline.slice(0, 110),
    description: input.description,
    mainEntityOfPage: { "@type": "WebPage", "@id": input.path },
    url: input.path,
    ...(input.image ? { image: [input.image] } : {}),
    ...(input.section ? { articleSection: input.section } : {}),
    ...(input.keywords?.length ? { keywords: input.keywords.join(", ") } : {}),
    inLanguage: "en-US",
    isAccessibleForFree: true,
    author: { "@type": "Organization", name: "USA Lottery Club" },
    publisher: { "@type": "Organization", name: "USA Lottery Club" },
  };
}

export function stateSchema(input: { name: string; abbreviation: string; path: string; description: string }) {
  return {
    "@context": "https://schema.org",
    "@type": "State",
    name: input.name,
    alternateName: input.abbreviation,
    url: input.path,
    description: input.description,
    containedInPlace: { "@type": "Country", name: "United States", alternateName: "US" },
  };
}

export function gameSchema(input: {
  name: string;
  path: string;
  description: string;
  stateName?: string;
  numberOfPlayers?: never;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Game",
    name: input.name,
    url: input.path,
    description: input.description,
    genre: "Lottery",
    category: "Lottery",
    ...(input.stateName
      ? { audience: { "@type": "Audience", audienceType: `${input.stateName} lottery players`, geographicArea: { "@type": "State", name: input.stateName } } }
      : {}),
  };
}

export function itemListSchema(name: string, links: Array<{ label: string; href: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    itemListElement: links.map((l, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: l.label,
      url: l.href,
    })),
  };
}
